<!-- filepath: /Users/minus4/Kod/Bitbucket/new-muzible-www-login/src/views/ForgotPassword.vue -->

<template>
  <div class="forgot-password-root">
    <div class="forgot-password-scroll-container">
      <div class="forgot-password-content-wrapper">
        <div class="fonts-white">
          
          <!-- Logo Section -->
          <div v-if="!this.$store.getters.getUserData" class="logo-section">
            <LogoWhite @click="handleClickMenu('muzible')" class="logo-clickable"></LogoWhite>
          </div>

          <!-- Typing Animation Header - Before Reset -->
          <div v-if="!passwordResetOK" class="typing-section">
            <div class="typing-container">
              <div class="fonts-head typing-text" id="feature-text">
                {{ dynamicText }}
                <span class="cursor"></span>
              </div>
            </div>
          </div>

          <!-- Typing Animation Header - After Reset -->
          <div v-if="passwordResetOK" class="typing-section">
            <div class="typing-container">
              <div class="fonts-head typing-text" id="feature-text2">
                {{ dynamicText2 }}
                <span class="cursor"></span>
              </div>
            </div>
          </div>

          <!-- Forgot Password Card -->
          <div class="forgot-password-card-section">
            <div class="forgot-password-card">
              <v-card class="forgot-password-form-card">
                <v-card-text class="forgot-password-form-content">
                  
                  <!-- Form - Before Reset -->
                  <v-form v-if="!passwordResetOK" ref="formforgot" v-model="forgotPassword" id="check-password-form">
                    <v-text-field 
                      v-model="emailForgot" 
                      class="email-font mb-4" 
                      :rules="emailRulesForgot"
                      label="ENTER EMAIL" 
                      required 
                      color="#1ff050" 
                      @focus="checkErrorsForgot()"
                      :error-messages="emailValidationForgotErrors"
                      variant="outlined"
                      density="comfortable"
                    ></v-text-field>
                  </v-form>

                  <!-- Reset Button -->
                  <div v-if="!passwordResetOK" class="button-section">
                    <v-btn 
                      type="submit" 
                      form="check-password-form" 
                      :disabled="!forgotPassword" 
                      color="#000000"
                      variant="outlined"
                      class="reset-btn"
                      size="large"
                      block
                      @click="forgotPass($event)"
                    >
                      <v-icon left>mdi-lock-reset</v-icon>
                      <span>Reset Password</span>
                    </v-btn>
                  </div>

                  <!-- Back to Login Link -->
                  <div v-if="!passwordResetOK" class="back-link-section">
                    <span class="sign-up-text-policy">
                      Back to
                      <span class="link-accept-signup" @click="handleClickMenu('login')">
                        Log in
                      </span>
                    </span>
                  </div>

                  <!-- Success Message -->
                  <div v-if="passwordResetOK" class="success-message">
                    <v-icon size="64" color="#1ff050" class="mb-4">mdi-email-check-outline</v-icon>
                    <p class="success-text">
                      We have sent an email to you for verification. Follow the link provided to reset your password.
                    </p>
                    <p class="success-text-small">
                      In case you receive no email, check the spam folder. For more info please contact us at 
                      <a class="link-email" href="mailto:contact@muzible.com">contact@muzible.com</a>
                    </p>
                  </div>

                  <!-- Back to Login Button - After Success -->
                  <div v-if="passwordResetOK" class="button-section-success">
                    <v-btn 
                      color="#000000"
                      variant="outlined"
                      class="back-btn"
                      size="large"
                      block
                      @click="handleClickMenu('login')"
                    >
                      <v-icon left>mdi-arrow-left</v-icon>
                      <span>Back to Log in</span>
                    </v-btn>
                  </div>

                </v-card-text>
              </v-card>

              <!-- Footer Links -->
              <div class="footer-links">
                <div class="footer-buttons-container">
                  <button 
                    class="footer-link-btn"
                    @click="handleClickMenu('Terms')"
                  >
                    <v-icon size="14" class="footer-link-icon">mdi-file-document-outline</v-icon>
                    <span>Terms of use</span>
                  </button>
                  
                  <div class="separator-dot"></div>
                  
                  <button 
                    class="footer-link-btn"
                    @click="handleClickMenu('Privacy')"
                  >
                    <v-icon size="14" class="footer-link-icon">mdi-shield-lock-outline</v-icon>
                    <span>Privacy policy</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>

import LogoWhite from '../components/logo_white.vue';

export default {
  name: 'ForgotPassword',

  components: {
    LogoWhite
  },
  data: () => ({
    delay: 80,
    passwordResetOK: false,
    forgotPassword: false,
    emailForgot: '',
    emailValidationForgotErrors: [],
    dynamicText: '',
    dynamicText2: '',
    text: 'Reset password',
    text2: '',
  }),
  mounted() {
    this.typeText(0);
  },
  beforeUnmount() {

  },
  destroyed() {
  },
  computed: {
    emailRulesForgot() {
      return [
        v => {
          this.emailValidationForgotErrors = [];
          var val = !!v
          if (val) {
            return true
          } else {
            return 'E-mail is required'
          }
        },
        v => /.+@.+/.test(v) || 'E-mail must be valid',
        v => /(^.+@(\[?)[a-zA-Z0-9-.]+.([a-zA-Z]{2,3}|[0-9]{1,3})(]?)$)/.test(v) || 'E-mail must be valid',
        v => /^[a-zA-Z0-9!'#$%&*+\\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!'#$%&*+\\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/.test(v) || 'E-mail must be valid'
      ]
    },
  },
  created() {
    if (this.$refs.formforgot) {
      this.$refs.formforgot.resetValidation();
    }
    this.passwordResetOK = false;
  },
  methods: {
    forgotPass(e) {
      this.forgotPassword = false;
      this.$store.dispatch('forgotpass', { email: this.emailForgot }
      ).then(response => {
        this.typeText2(0);
        this.passwordResetOK = true;
      }).catch(error => {
        if (!error.response) {
          this.emailValidationForgotErrors = ['Service is down.. Try again later!'];
        } else {
          this.emailValidationForgotErrors = ['Error occured.. Try again later!'];
        }
      });
      e.preventDefault()
    },
    async typeText2(num) {
      let i = 0;
      while (i < this.text2.length) {
        await this.waitForMs(this.delay);
        this.dynamicText2 += this.text2[i];
        i++;
      }
      await this.waitForMs(2000);
      if (num === 0) {
        this.text2 = 'Check your mailbox'
        this.dynamicText2 = '';
        this.typeText2(1);
      } else {
        this.text2 = 'Follow the link!'
        this.dynamicText2 = '';
        this.typeText2(0);
      } 
    },
    async typeText(num) {
      let i = 0;
      while (i < this.text.length) {
        await this.waitForMs(this.delay);
        this.dynamicText += this.text[i];
        i++;
      }
      await this.waitForMs(2000);
      if (num === 0) {
        this.text = '1. Type in email'
        this.dynamicText = '';
        this.typeText(1);
      } else if (num === 1) {
        this.text = '2. Check your mailbox'
        this.dynamicText = '';
        this.typeText(2);
      } else if (num === 2) {
        this.text = '3. Follow the link!'
        this.dynamicText = '';
        this.typeText(3);
      } else {
        await this.waitForMs(4000);
        this.dynamicText = '';
        this.text = 'Reset password'
        this.typeText(0)
      }
    },
    waitForMs(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    handleClickMenu(link) {
      if (link === 'Terms') {
        window.open('https://muzible.com/terms', '_blank');
      } else if (link === 'Privacy') {
        window.open('https://muzible.com/privacy', '_blank');
      } else {
        if (this.$route.name !== link) {
          this.$router.push({ name: link });
        }
      }
    },
    checkErrorsForgot() {
      if (this.emailValidationForgotErrors.length != 0
        && (this.emailValidationForgotErrors[0] === 'Service is down.. Try again later!' ||
          this.emailValidationForgotErrors[0] === 'Error occured.. Try again later!')) {
        this.emailValidationForgotErrors = [];
      }
    },

  },
}
</script>

<style lang="scss" scoped>
@use './css/styles.scss';

/* Forgot Password Root - Complete Override */
.forgot-password-root {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  height: 100dvh !important;
  overflow: hidden !important;
  z-index: 1 !important;
}

/* Forgot Password Scroll Container - Main Scrollable Area */
.forgot-password-scroll-container {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  background: linear-gradient(145deg, rgba(0, 0, 0, 0.95), rgba(18, 18, 18, 0.95));
  
  /* Smooth scrolling */
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  
  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }
  
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

/* Forgot Password Content Wrapper */
.forgot-password-content-wrapper {
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 40px 20px 60px 20px;
}

/* Logo Section */
.logo-section {
  display: flex;
  justify-content: center;
  margin-bottom: 32px;
}

.logo-clickable {
  cursor: pointer;
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.logo-clickable:hover {
  transform: scale(1.05);
  opacity: 0.9;
}

/* Typing Section */
.typing-section {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
}

.typing-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60px;
}

.typing-text {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 32px;
  font-weight: 600;
  color: white;
  text-align: center;
}

.cursor {
  display: inline-block;
  width: 3px;
  height: 32px;
  background-color: white;
  margin-left: 4px;
  animation: blink 0.6s linear infinite alternate;
}

@keyframes blink {
  0% { opacity: 1; }
  40% { opacity: 1; }
  60% { opacity: 0; }
  100% { opacity: 0; }
}

/* Forgot Password Card Section */
.forgot-password-card-section {
  display: flex;
  justify-content: center;
  min-width: 370px;
  max-width: 500px;
}

.forgot-password-card {
  width: 100%;
  max-width: 500px;
  animation: slideIn 0.4s ease forwards;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.forgot-password-form-card {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.95), rgba(18, 18, 18, 0.95)) !important;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  transition: all 0.3s ease;
}

.forgot-password-form-card:hover {
  border-color: rgba(255, 255, 255, 0.2);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.5);
}

.forgot-password-form-content {
  padding: 32px 24px !important;
}

/* Button Section */
.button-section {
  margin-top: 16px;
  margin-bottom: 16px;
}

/* Button Section Success */
.button-section-success {
  margin-top: 8px;
  margin-bottom: 8px;
}

/* Back Link Section */
.back-link-section {
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
}

/* Form Fields */
.email-font {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 16px !important;
}

.email-font :deep(.v-field) {
  background: rgba(255, 255, 255, 0.05) !important;
  border-radius: 12px;
}

.email-font :deep(.v-field__outline) {
  color: rgba(255, 255, 255, 0.2);
}

.email-font :deep(.v-field--focused .v-field__outline) {
  color: #1ff050 !important;
}

.email-font :deep(.v-field__input) {
  color: white !important;
}

.email-font :deep(.v-label) {
  color: rgba(255, 255, 255, 0.6) !important;
}

.email-font :deep(.v-field--focused .v-label) {
  color: #1ff050 !important;
}

/* Reset Button */
.reset-btn {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 18px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  padding: 24px !important;
  border: 2px solid rgba(31, 240, 80, 0.5) !important;
  background: linear-gradient(135deg, rgba(31, 240, 80, 0.1) 0%, rgba(31, 240, 80, 0.05) 100%) !important;
  color: #1ff050 !important;
  transition: all 0.3s ease;
}

.reset-btn:hover:not(:disabled) {
  border-color: rgba(31, 240, 80, 0.8) !important;
  background: linear-gradient(135deg, rgba(31, 240, 80, 0.2) 0%, rgba(31, 240, 80, 0.1) 100%) !important;
  transform: translateY(-2px);
  box-shadow: 0 8px 16px rgba(31, 240, 80, 0.2);
}

.reset-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  border-color: rgba(255, 255, 255, 0.2) !important;
  color: rgba(255, 255, 255, 0.4) !important;
  background: rgba(255, 255, 255, 0.05) !important;
}

/* Back Button */
.back-btn {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 18px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  padding: 24px !important;
  border: 2px solid rgba(255, 255, 255, 0.3) !important;
  background: rgba(255, 255, 255, 0.05) !important;
  color: white !important;
  transition: all 0.3s ease;
}

.back-btn:hover {
  border-color: rgba(255, 255, 255, 0.5) !important;
  background: rgba(255, 255, 255, 0.1) !important;
  transform: translateY(-2px);
  box-shadow: 0 8px 16px rgba(255, 255, 255, 0.1);
}

/* Success Message */
.success-message {
  text-align: center;
  padding: 24px 16px;
}

.success-text {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 18px !important;
  color: rgba(255, 255, 255, 0.9) !important;
  line-height: 1.6;
  margin-bottom: 16px;
}

.success-text-small {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 14px !important;
  color: rgba(255, 255, 255, 0.7) !important;
  line-height: 1.5;
}

.link-email {
  color: #1ff050 !important;
  text-decoration: underline !important;
  text-decoration-style: solid !important;
  text-decoration-color: #1ff050 !important;
  text-underline-offset: 2px !important;
  transition: all 0.3s ease;
}

.link-email:hover {
  text-decoration-thickness: 2px !important;
  opacity: 0.8;
}

/* Back to Login Link */
.sign-up-text-policy {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 16px !important;
  color: rgba(255, 255, 255, 0.7) !important;
  text-align: center;
}

.link-accept-signup {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 16px !important;
  color: #1ff050 !important;
  text-decoration: underline !important;
  text-decoration-style: solid !important;
  text-decoration-color: #1ff050 !important;
  text-underline-offset: 4px !important;
  cursor: pointer;
  transition: all 0.3s ease;
}

.link-accept-signup:hover {
  text-decoration-thickness: 2px !important;
  opacity: 0.8;
}

/* Footer Links */
.footer-links {
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-buttons-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.footer-link-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.7);
  font-family: "Darker Grotesque", sans-serif;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  outline: none;
}

.footer-link-btn:hover {
  color: white;
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
}

.footer-link-btn:active {
  transform: translateY(0);
}

.footer-link-icon {
  opacity: 0.8;
}

.separator-dot {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
}

/* Button Overlay Override */
:deep(.v-btn:hover) > .v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-btn[aria-haspopup=menu][aria-expanded=true]) > .v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-btn[aria-haspopup=menu][aria-expanded=true]:hover) > .v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .forgot-password-content-wrapper {
    padding: 120px 16px 60px 16px;
  }

  .typing-text {
    font-size: 24px;
  }

  .cursor {
    height: 24px;
  }

  .forgot-password-form-content {
    padding: 24px 20px !important;
  }

  .reset-btn,
  .back-btn {
    font-size: 16px !important;
    padding: 20px !important;
  }

  .success-text {
    font-size: 16px !important;
  }

  .success-text-small {
    font-size: 13px !important;
  }

  .footer-links {
    margin-top: 24px;
    padding-top: 20px;
  }

  .footer-buttons-container {
    gap: 12px;
  }

  .footer-link-btn {
    padding: 6px 12px;
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .forgot-password-content-wrapper {
    padding: 80px 16px 60px 16px;
  }

  .typing-text {
    font-size: 20px;
  }

  .cursor {
    height: 20px;
  }

  .forgot-password-form-content {
    padding: 20px 16px !important;
  }

  .success-message {
    padding: 20px 12px;
  }

  .footer-buttons-container {
    flex-direction: column;
    gap: 8px;
  }

  .separator-dot {
    display: none;
  }

  .footer-link-btn {
    width: 100%;
    justify-content: center;
  }
}

/* Loading State for Button */
.reset-btn :deep(.v-btn__loader),
.back-btn :deep(.v-btn__loader) {
  color: #1ff050 !important;
}

/* Focus States */
.email-font :deep(.v-field--focused) {
  box-shadow: 0 0 0 2px rgba(31, 240, 80, 0.2);
}

/* Error State */
.email-font :deep(.v-field--error .v-field__outline) {
  color: #d32f2f !important;
}

.email-font :deep(.v-field--error .v-label) {
  color: #d32f2f !important;
}

/* Accessibility */
.reset-btn:focus-visible,
.back-btn:focus-visible {
  outline: 2px solid #1ff050;
  outline-offset: 2px;
}

.link-accept-signup:focus-visible,
.link-email:focus-visible {
  outline: 2px solid #1ff050;
  outline-offset: 2px;
  border-radius: 4px;
}

.footer-link-btn:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.5);
  outline-offset: 2px;
}

/* Success Icon Animation */
@keyframes iconPulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.1); }
}

.success-message .v-icon {
  animation: iconPulse 2s ease-in-out infinite;
}

</style>